/// <reference path="admin.items.js" />

export default function HelpMaintenanceItemsService(gettext) {
	'ngInject';

	this.getModule = function () {
		var module = {
			id: 'maintenance',
			name: gettext('Maintenance'),
			description: gettext(
				'This is where maintenance plans are created and managed. Maintenance Plans are used to keep track of when maintenance must be performed on assets, and which tasks need to be completed as part of the maintenance plans.'
			),
			icon: 'fas fa-question-circle',
			priority: 4,
			items: [
				{
					orderid: 4.1,
					itemid: 'maintenanceboard',
					helpitemid: 'maintenance',
					name: gettext('Dashboard'),
					templateUrl: 'maintenance/maintenance.dashboard.html'
				},
				{
					orderid: 4.2,
					itemid: 'maintenancecomplete',
					helpitemid: 'maintenance.complete',
					name: gettext('Complete Maintenance'),
					templateUrl: 'maintenance/maintenance.complete.html'
				},
				{
					orderid: 4.3,
					itemid: 'maintenancehistory',
					helpitemid: 'maintenance',
					name: gettext('Maintenance History'),
					templateUrl: 'maintenance/maintenance.history.html'
				},
				{
					orderid: 4.4,
					itemid: 'maintenancehistorydetails',
					helpitemid: 'maintenance',
					name: gettext('Maintenance History Details'),
					templateUrl: 'maintenance/maintenance.details.html'
				},
				{
					orderid: 4.5,
					itemid: 'maintenanceplans',
					helpitemid: 'maintenance.plans',
					name: gettext('View Existing Plans'),
					templateUrl: 'maintenance/maintenance.plans.html'
				},
				{
					orderid: 4.6,
					itemid: 'maintenanceplansdetail',
					helpitemid: 'maintenance.plans',
					name: gettext('Maintenance Plan Details'),
					templateUrl: 'maintenance/maintenance.plans.details.html'
				},
				{
					orderid: 4.7,
					itemid: 'maintenancecreateplan',
					helpitemid: 'maintenance.plans.manage',
					name: gettext('Create Maintenance Plan'),
					templateUrl: 'maintenance/maintenance.plans.create.html'
				}
			]
		};

		return module;
	};
}
